import React, { useRef, useEffect } from 'react';
import { gsap } from '../../../gsap';
import './CopyBlocks.scss';

function CopyWithBar({ copyData }) {
  const container = useRef();
  const bar = useRef();

  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: container.current,
        start: 'top 60%'
      }
    });

    tl.to(bar.current, {
      height: '100%',
      duration: 0.7
    });
  }, [copyData]);

  return (
    <div className="copyWithBar" ref={container}>
      <div className="copyWithBar__bar" ref={bar} />
      <p className="copyWithBar__copy">{copyData}</p>
    </div>
  );
}

export default CopyWithBar;
